module.exports = {
  "divider": {
    "height": "2",
    "backgroundColor": "#3d3d42"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-4c766cb6!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-divider/index.vue
// module id = 472
// module chunks = 0 1